import React from 'react'
import { Link, useLocation } from 'react-router-dom';
import Footer from '../../../../Layout/Footer';
import Header from '../../../../Layout/Header';
import feedback from '../../../../../assets/img/notify.jpg';
import { useEffect } from 'react';
import { getOfferBuyer } from '../../../../../Redux/Task/action';
import { useState } from 'react';
import { IMAGE_URL } from '../../../../../api';

const MytaskHistoryBuyer = () => {

    const { state } = useLocation();
    const [tasks, setTasks] = useState([])
    useEffect(() => {
        getOfferBuyer(state?.data?.task_details_id)((response) => {
            if (response && response.status) {
                setTasks(response?.data?.data)
            }
        });
    }, []);
    return (
        <React.Fragment>
            <Header />
            <section>
                <div className="breadcrumbs">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 my-auto">
                                <h1>My Task </h1>
                                <ul className="trail-items">
                                    <li className="trail-item trail-begin">
                                        <Link to="/">
                                            <span itemProp="name">Home</span><i className="bi bi-chevron-double-right"></i>
                                        </Link>
                                    </li>
                                    <li className="trail-item trail-end">
                                        <span itemProp="item"><span itemProp="name"> Task Details</span></span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="mytask-details">
                <div className="container">

                    <div className="row task-history-main">
                        <div className="member">
                            <div className="pic"><img src={IMAGE_URL + state?.data?.image[0]?.image} className="img-fluid" alt="" /></div>
                            <div className="member-info">
                                <h4>{state?.data?.user?.username}</h4>
                                {state?.data?.average_rating == "" ?
                                    <></>
                                    :
                                    <p>{parseFloat(state?.data?.average_rating).toFixed(1)} <i class="bi bi-star-fill"></i> Rating</p>
                                }
                            </div>

                        </div>
                        <div className='member-details'>
                            <h4>Experience: {parseFloat(state?.data?.experience).toFixed(1)}</h4>
                            <h4>Bio: {state?.data?.about_yourself}</h4>
                            <h4>Customer Rating:</h4>
                            {tasks?.map((task, index) => (
                                <React.Fragment>
                                    {task?.review?.map((review, index) => (
                                        <div className='border-bottom-experience'>
                                            <span className="badge badge-light-warning">{parseFloat(review?.rating).toFixed(1)} <i class="bi bi-star-fill"></i></span>
                                            <p className='mt-2'>{review?.comment}</p>
                                        </div>
                                    ))

                                    }
                                </React.Fragment>
                            )

                            )}
                            {/* {state.data?.review?.map((review, index) => (
                                <div className='border-bottom-experience'>
                                    <span className="badge badge-light-warning">{parseFloat(review?.rating).toFixed(1)} <i class="bi bi-star-fill"></i></span>
                                    <p className='mt-2'>{review?.comment}</p>
                                </div>
                            ))} */}
                        </div>
                        <h4>Service History</h4>
                        {tasks?.map((task, index) => (
                            <React.Fragment>
                                {task?.service_history?.map((service, index) => (
                                    <div className='member-details-hist'>
                                        <div className='service-history'>
                                            <div className='member-details-left'>

                                                <p className='title'>{service?.task_details?.title}</p>
                                                <p style={{ color: "#000", fontWeight: "700" }}>Buyer: <span style={{ color: "#1bbaed", fontWeight: "700" }}>{service?.user_data[0]?.username}</span></p>
                                                <p>{service?.task_details?.description}</p>
                                            </div>
                                            <div className='member-details-right'>
                                                {service?.bid_rate == "" ?
                                                    <>
                                                        <p className='bid-rate'>Call rate: {service?.call_rate}/{service?.time_field == "1" ? 'hour' : service?.time_field == "2" && 'min'}</p>
                                                        <p className='bid-rate'>Chat rate: {service?.chat_rate}</p>
                                                    </>
                                                    :
                                                    <p className='bid-rate'>Bid rate: {service?.bid_rate}</p>

                                                }
                                                <p className='completed'><i class="bi bi-check-circle me-2"></i> Completed</p>
                                            </div>
                                        </div>

                                    </div>
                                ))

                                }
                            </React.Fragment>
                        )

                        )}
                        {/* <div className='member-details-hist'>
                            <div className='service-history'>
                                <div className='member-details-left'>
                                    <h4>Service History</h4>
                                    <p>Gst testing</p>
                                    <p>Buyer: Kaveri</p>
                                    <p>Testjhlihi</p>
                                </div>
                                <div className='member-details-right'>
                                    <p className='bid-rate'>Bid rate: 20.0</p>
                                    <p className='completed'><i class="bi bi-check-circle"></i> Completed</p>
                                </div>
                            </div>

                        </div> */}
                    </div>

                </div>
            </section>
            <Footer />
        </React.Fragment >
    )
}

export default MytaskHistoryBuyer;